import React from "react";
import "../App.css"

const styles = {
  section: {
    padding: "60px 20px",
    textAlign: "center",
    background: "#fff",
  },
  label: {
    display: "inline-block",
    backgroundColor: "#ffe9f0",
    color: "#e60023",
    fontSize: "14px",
    padding: "6px 16px",
    borderRadius: "20px",
    fontWeight: "bold",
    marginBottom: "15px",
  },
  heading: {
    fontSize: "36px",
    color: "#b0001f",
    fontWeight: "bold",
    marginBottom: "15px",
  },
  subText: {
    fontSize: "16px",
    color: "#555",
    maxWidth: "700px",
    margin: "0 auto 40px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "20px",
    margin: "0 auto",
  },
  videoWrapper: {
    position: "relative",
    paddingBottom: "56.25%", // 16:9 aspect ratio
    height: 0,
    overflow: "hidden",
    borderRadius: "12px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  },
  iframe: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    border: "0",
  },
};

const videos = [


  // YouTube Shorts
  "https://www.youtube.com/embed/BIRtJe4LAVk",
  "https://www.youtube.com/embed/HH81IP0QoHQ",

  // Normal YouTube video
  "https://www.youtube.com/embed/x1-Btxjz_vY",
];

export default function VideoGrid() {
  return (
    
    <div style={styles.section}>
      <div style={styles.label}>🎥 CUSTOMER VIDEOS 🎥</div>
      <h2 style={styles.heading}>Watch Their Experiences</h2>
      <p style={styles.subText}>
        See how travelers enjoyed their journey with us through real customer
        videos.
      </p>

      <div style={styles.grid}>
        {videos.map((src, index) => (
          <div key={index} style={styles.videoWrapper}>
            <iframe
              src={src}
              title={`video-${index}`}
              style={styles.iframe}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        ))}
      </div>
    </div>
  );
}
